<template>
<table class="ui celled striped table">
  <tbody>
    <tr v-for="(form, i) in announcementForms" :key="i">
      <td>
        <form class="ui form" :class="{'warning': form.hasErrors()}">
          <div class="field" :class="{'required': !form.model.id}">
            <label>お知らせタイトル</label>
            <template v-if="form.model.id">
              <div>{{ form.model.title }}</div>
            </template>
            <template v-else>
              <input type="text" v-model="form.model.title">
              <validation-message :form="form" field="title"></validation-message>
            </template>
          </div>
          <div class="field" :class="{'required': !form.model.id}">
            <label>URL</label>
            <template v-if="form.model.id">
              <a :href="form.model.url">{{ form.model.url }}</a>
            </template>
            <template v-else>
              <input type="text" v-model="form.model.url">
              <validation-message :form="form" field="url"></validation-message>
            </template>
          </div>
          <validation-message :form="form" field="template_max"></validation-message>
        </form>
      </td>
      <td class="actions">
        <button v-if="!form.model.id" type="button" class="ui tiny positive button" @click="saveAnnouncementTemplate(form)">保存</button>
        <button type="button" class="ui tiny red button" @click="deleteAnnouncementTemplate(form, i)">削除</button>
      </td>
    </tr>
  </tbody>
  <tfoot v-if="announcementForms.length < 10" class="full-width">
    <th colspan="2">
      <div class="ui center aligned">
        <i class="clickable plus green large icon" @click="newAnnouncementTemplate()"></i>
      </div>
    </th>
  </tfoot>
</table>
</template>

<script>
export default {
    data: function() {
        return {
            model: {},
            announcementForms: [],
            form: this.createForm(),
        };
    },
    created: function() {
        this.form.get('/afadmin/api/announcements', function(response) {
            this.announcementForms = response.data.map(function(announcement) {
                return this.createForm(announcement);
            }.bind(this));
        }.bind(this));
    },
    methods: {
        newAnnouncementTemplate: function() {
            if (this.announcementForms.length < 10) {
                this.announcementForms.push(this.createForm());
            }
        },
        saveAnnouncementTemplate: function(form) {
            form.post('/afadmin/api/announcements', function(response) {
                this.merge(form.model, response.data);
                alert('保存しました');
            });
        },
        deleteAnnouncementTemplate: function(form, i) {
            if (!form.model.id) {
                this.announcementForms.splice(i, 1);
                return;
            }
            if (!confirm('削除します。よろしいですか？')) {
                return;
            }
            form.delete(form.model.detail_api_url, function() {
                this.announcementForms.splice(i, 1);
            }.bind(this));
        },
    }
};
</script>
